"use strict";

var PhotoSwipe = require("photoswipe"),
	PhotoSwipeUI_Default = require("photoswipe/dist/photoswipe-ui-default"),
	pswpTpl = require("./pswp.html");

require("photoswipe/dist/photoswipe.css");
require("photoswipe/dist/default-skin/default-skin.css");

require("./photo-swipe-custom.scss");

const renderIsOldPackaging = (gallery) => {
	const wrapper = gallery.bg.parentElement;
	const wobblerElement = wrapper.querySelector('.pswp__wobbler');

	if (wobblerElement) {
		wobblerElement.remove();
	}

	if (!gallery.currItem.isOldPackaging) {
		return;
	}

	wrapper.insertAdjacentHTML('beforeend', `
		<div class="pswp__wobbler">
			<div class="wobblers wobblers--gallery">
				<ul class="wobblers__list">
					<li class="wobblers__item wobblers__item_hit"><span>Старая упаковка</span></li>
				</ul>
			</div>
		</div>
	`);
};

$(document).on("click.jsPswpLink", ".jsPswpLink", function (event) {
	event.preventDefault();

	var $this = $(this),
		guid = $this.attr("data-pswp-guid"),
		$galleryWrap = $this.closest(".jsPswpGallery"),
		index = 0,
		items = [],
		$links,
		gallery;
	const { wobblerHtml } = $galleryWrap[0].dataset;

	if(guid) {
		$links = $(`[data-pswp-guid="${guid}"]`);
	} else if($galleryWrap.length) {
		$links = $galleryWrap.find(".jsPswpLink");
	} else {
		$links = $this;
	}

	$links = $links.map(function (i, el) {
		var $link = $(el),
			size = $link.attr("data-pswp-size") || "",
			[w,h] = size.split("x").map(item => parseInt(item)),
			src = $link.attr("href") || $link.attr("data-pswp-src"),
			msrc = $link.find("img").eq(0).attr("src") || $link.attr("data-pswp-msrc"),
			item;

		if(!w || !h) {
			[w, h] = [0,0];
		}

		if(!src) {
			console.warn($link, "pswp-link must have link to image (href or data-pswp-src attribute)");
			return null;
		}

		item = {src,w, h};

		if(msrc) {
			item.msrc = msrc;
		}

		item.isOldPackaging = el.hasAttribute('data-is-old-packaging');

		items.push(item);

		if($link.is($this)) index = i;

		return el;
	});

	gallery = new PhotoSwipe( getPswpElem(), PhotoSwipeUI_Default, items, {
		index : index,
		shareEl: false,
		history: false,
		getThumbBoundsFn : function (i) {
			var $link = $links.eq(i),
				$thumb = $link.find("img").eq(0),
			    {left:x, top:y} = $thumb.offset(),
			    w = $thumb.width();

			if($link.is(":visible") && $link.attr("data-pswp-size")) {
				return {x,y,w};
			}
		}
	});

	gallery.listen("gettingData", function(i, item) {
		renderIsOldPackaging(gallery);

		if(!item.w || !item.h) {
			let img = new Image(),
				timer;

			img.src = item.src;
			timer = setInterval(() => {
				if(img.naturalHeight && img.naturalWidth) {
					item.w = img.naturalWidth;
					item.h = img.naturalHeight;
					clearInterval(timer);
					img.src = "";
					gallery.updateSize(true);
					$links.eq(i).attr("data-pswp-size", item.w + "x" + item.h);
				}
			}, 100);
		}
	});

	gallery.init();
});

function getPswpElem() {
	var $pswp = $(".pswp");

	if(!$pswp.length) {
		$pswp = $(pswpTpl).appendTo("body");
	}

	return $pswp[0];
}



/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/photoSwipe/index.js
 **/